import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "../lib/api";
import LegalUpdateGate from "../components/LegalUpdateGate";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=loading, false=anon, obj=auth
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
      return data;
    } catch {
      setUser(false);
      return null;
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const login = async (email, password) => {
    await api.post("/auth/login", { email, password });
    return await refresh(); // returns full user (including legal version fields)
  };
  const register = async (payload) => {
    await api.post("/auth/register", payload);
    return await refresh();
  };
  const logout = async () => {
    try { await api.post("/auth/logout"); } catch {}
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, register, logout, refresh, setUser }}>
      {children}
      <LegalUpdateGate />
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
